"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiCallLogger = exports.apiCall = void 0;

require("core-js/modules/es.promise.js");

require("core-js/modules/es.json.stringify.js");

var _axios = _interopRequireDefault(require("axios"));

var _helpers = require("./helpers");

var _mocking = _interopRequireDefault(require("../mocking"));

var _logger = _interopRequireDefault(require("../mocking/logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Change for nexus dependency when available
// Add config and logger to package.json as regular dependencies when available on nexus

/**
 * apiCall
 * @param {object} options - Object with the options for the axios call
 * @param {number} options.sessionId - Session Id to be sent to the logger
 * @param {string} options.uiRequestorComponent - Component requesting the axios request
 * @param {string} options.resource - Key of the resource available in config file
 * @param {number} [options.userId = 0] - Id of the current user
 * @param {string} [options.method = 'get'] - Method of the axios call
 * @param {string[]} [options.requestedFields = []] - Requeired fields from the response
 * @param {any} [options.body = null] - Body to be sent in the request
 * @param {object} [options.extraHeaders = null] - Extra headers to be sent in the request
 * @param {boolean} [options.log = false] - Extra headers to be sent in the request
 * @returns Promise (async func)
 */
// Flow
// Requestor comp -> useStore helpers -> apiCall -> useStore helpers -> useStore -> requestor comp receives promise
// Implementation as async
const apiCall = async function apiCall(options) {
  const sessionId = options === null || options === void 0 ? void 0 : options.sessionId; // Required for logger

  const uiRequestorComponent = options === null || options === void 0 ? void 0 : options.uiRequestorComponent; // Required for logger

  const resource = options === null || options === void 0 ? void 0 : options.resource;
  const resourceConfig = _mocking.default[resource]; // Required fields validation

  if (![sessionId, uiRequestorComponent, resource, resourceConfig].every(element => element)) return {
    data: "Required fields not sent or no configuration available for the requested resource"
  };
  const userId = options.userId || 0; // 0 in case it is anonymous

  const method = options.method || resourceConfig.method || 'get';
  const requestedFields = options.requestedFields || resourceConfig.requestedFields || [];
  const host = options.host || resourceConfig.host || '';
  const extraHeaders = options.extraHeaders || null;
  const body = options.body || resourceConfig.body || null;
  const log = options.log || false;
  const requestHeaders = (0, _helpers.getHeaders)((resourceConfig === null || resourceConfig === void 0 ? void 0 : resourceConfig.headers) || {}, extraHeaders, (resourceConfig === null || resourceConfig === void 0 ? void 0 : resourceConfig.allowedExtraHeaders) || []);
  let responseLog, statusCodeLog, uuid;
  const testingData = {
    userId,
    method,
    requestedFields,
    extraHeaders,
    body,
    log,
    requestHeaders
  };
  const request = {
    method,
    baseURL: host,
    url: resourceConfig.path,
    data: method.toLowerCase() === 'get' ? null : body,
    headers: requestHeaders
  };

  try {
    var _res$data;

    const res = await (0, _axios.default)(_objectSpread(_objectSpread({}, request), {}, {
      timeout: resourceConfig.timeout || 0
    }));
    const filteredResponse = (0, _helpers.filterObject)(res.data, requestedFields);
    responseLog = res.data; // Should the logged data be the whole response or the filtered response?

    statusCodeLog = res.status;
    uuid = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uuid;
    if (log) (0, _logger.default)({
      method,
      request,
      message: responseLog,
      //Required
      statusCode: statusCodeLog,
      //Required
      uuid,
      //Required
      userId,
      //Required
      correlationId: sessionId,
      //Required - Is this corect? Correlation Id is the session id?
      componentName: uiRequestorComponent,
      //Required
      date: Date.now() //Required

    });
    if (process.env.NODE_ENV !== "production") return {
      data: filteredResponse,
      status: statusCodeLog,
      testingData
    };else return {
      data: filteredResponse,
      status: statusCodeLog
    };
  } catch (error) {
    var _error$response, _error$response2, _error$response3, _error$response3$data;

    responseLog = ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || JSON.stringify(error);
    statusCodeLog = ((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) || 400; // Or log 200 for errors?

    uuid = ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.uuid) || null;
    apiCallLogger({
      method,
      request,
      message: responseLog,
      //Required
      statusCode: statusCodeLog,
      //Required
      uuid,
      //Required
      userId,
      //Required
      correlationId: sessionId,
      //Required - Is this corect? Correlation Id is the session id?
      componentName: uiRequestorComponent,
      //Required
      date: Date.now() //Required

    });
    if (process.env.NODE_ENV !== "production") return {
      status: statusCodeLog,
      testingData
    };
    return {
      status: statusCodeLog
    };
  }
};
/**
 * apiCallLogger
 * @param {object} data - Data to be logged
 * @returns Promise
 */


exports.apiCall = apiCall;

const apiCallLogger = function apiCallLogger(data) {
  return new Promise(async function (resolve) {
    try {
      await (0, _axios.default)({
        method: 'post',
        baseURL: _mocking.default['postLogging'].host,
        url: _mocking.default['postLogging'].path,
        data,
        headers: _mocking.default['postLogging'].headers
      });
    } catch (error) {}

    if (process.env.NODE_ENV !== "production") console.log(JSON.stringify(data));
    resolve();
  });
};
/**
 * Export all consts here
 */


exports.apiCallLogger = apiCallLogger;